import React from "react";

const selectionContext = React.createContext({
  // holds the list information from the selection screen
  currList: [],
  updateList: () => {}
});

export default selectionContext;
